import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { state, signal } from 'cerebral/tags'
import MenuItem from './menuItem'
import isAdmin from 'utils/isAdmin'
import styles from './styles'
import { css } from 'aphrodite'
import { t } from '@billes/translator-client'

export default connect(
  {
    group: state`app.user.group`,
    contextMenu: state`media.contextMenu`,
    isTagsMenuOpen: state`media.tags.open`,
    hideFileContextMenu: signal`media.hideFileContextMenu`,
    file: state`media.contextMenu.file`,
    onBeforeAddToBasket: signal`basket.onBeforeAddToBasket`,
    askDeleteFiles: signal`media.askDeleteFiles`,
    onShowDetailedView: signal`media.onShowDetailedView`,
    onOpenTagMenu: signal`media.onOpenTagMenu`
  },
  class ContextMenu extends Component {
    onBlur(e) {
      const { hideFileContextMenu } = this.props
      hideFileContextMenu()
    }

    renderItems() {
      const {
        file,
        group,
        onBeforeAddToBasket,
        askDeleteFiles,
        onShowDetailedView,
        isTagsMenuOpen,
        onOpenTagMenu
      } = this.props

      if (!file) {
        return
      }

      const fileItems = [
        {
          label: t('bms.media.titles.addSelectedFilesToBasket'),
          onSelect: e => {
            onBeforeAddToBasket()
          }
        },
        {
          label: t('bms.media.titles.showSelectedFilesInDetailedView'),
          onSelect: e => {
            onShowDetailedView()
          }
        }
      ]

      if (!isTagsMenuOpen) {
        fileItems.push({
          label: t('bms.media.titles.openTagsMenu'),
          onSelect: e => {
            onOpenTagMenu()
          }
        })
      }

      if (isAdmin(group)) {
        fileItems.push({
          label: t('bms.media.titles.deleteSelectedFiles'),
          onSelect: e => {
            askDeleteFiles()
          }
        })
      }

      return fileItems.map((item, index) => {
        return (
          <MenuItem key={index} label={item.label} onSelect={item.onSelect} />
        )
      })
    }

    render() {
      const { contextMenu: { isVisible, position } } = this.props
      if (!isVisible) return null
      return (
        <div
          ref={ref => ref && ref.focus()}
          className={css(styles.container)}
          tabIndex={0}
          style={{ left: position.x, top: position.y }}
          onBlur={e => this.onBlur(e)}
        >
          <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
            {this.renderItems()}
          </ul>
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/Media/ContextMenu/contextMenu.js